/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Inventory_OfflineInputs */



/**
* | output |
* | --- |
* | "Recording movements and the ledger need a connection." |
*
* @param {Promo_Inventory_OfflineInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_inventory_offline = /** @type {((inputs?: Promo_Inventory_OfflineInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Inventory_OfflineInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer les mouvements et consulter le registre nécessitent une connexion.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrar movimientos y consultar el registro requieren conexión.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Registrar movimentações e consultar o registro exigem conexão.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registrare i movimenti e consultare il registro richiedono una connessione.")
	return /** @type {LocalizedString} */ ("Recording movements and the ledger need a connection.")
});